/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_V2_Filter_Group_TypeInputs */

const en_home_v2_filter_group_type = /** @type {(inputs: Home_V2_Filter_Group_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File type`)
};

const es_home_v2_filter_group_type = /** @type {(inputs: Home_V2_Filter_Group_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de archivo`)
};

/**
* | output |
* | --- |
* | "File type" |
*
* @param {Home_V2_Filter_Group_TypeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const home_v2_filter_group_type = /** @type {((inputs?: Home_V2_Filter_Group_TypeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_V2_Filter_Group_TypeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_v2_filter_group_type(inputs)
	return en_home_v2_filter_group_type(inputs)
});